export const getInitials = (name: string): string => {
  if (!name) return '';
  const initials = name
    .split(' ')
    .filter((word) => word && word.trim() !== '')
    .map((word) => word[0]?.toUpperCase() || '')
    .join('');
  return initials.substring(0, 2);
};
export const capitalizeFirstLetterOfEachWord = (input: string): string => {
  return input.replace(/\b\w/g, (char) => char.toUpperCase());
};
